// extracted by mini-css-extract-plugin
export default {"titleDiv":"HotelDetail_titleDiv__GFKTf","imageDiv":"HotelDetail_imageDiv__IBETF","_1vjikx5":"HotelDetail__1vjikx5__Z7jbr"};